import { http } from '@shared/api';
import type { Category, CategoryKind, HsCode } from '../model/types';

function categoriesParams(kinds: CategoryKind[] | undefined): Record<string, string> | undefined {
  if (!kinds || kinds.length === 0) return undefined;
  // Spec contract: single kind goes through ?kind=PRODUCT, multiple — through
  // ?kinds=A,B. Backend rejects the plural form when given a single value.
  return kinds.length === 1 ? { kind: kinds[0]! } : { kinds: kinds.join(',') };
}

export const taxonomyApi = {
  listCategories: (kinds?: CategoryKind[]) =>
    http
      .get('taxonomy/categories', { searchParams: categoriesParams(kinds) })
      .json<Category[]>(),

  searchHsCodes: (q: string) =>
    http.get('taxonomy/hs-codes', { searchParams: { q } }).json<HsCode[]>(),
};
